import { render, staticRenderFns } from "./gruposcliente.vue?vue&type=template&id=5477f6e2"
import script from "./gruposcliente.vue?vue&type=script&lang=js"
export * from "./gruposcliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports